<template>
  <div class="text-secondary py-4">
    <div class="row items-center">
      <h4 class="col-9 text-uppercase">
        <span>{{ theme.theme_number }}</span>
        <span
          :class="isSelected ? 'text-decoration-underline' : null"
          class="ps-2"
        >
          {{ theme.name }}
        </span>
      </h4>
      <EntityImgContainer
        v-if="themeImage"
        class="col-3 pb-3 pe-0"
        :alt="theme.name"
        :img-url="themeImage"
      />
    </div>
    <div v-if="theme.description" class="row">
      <div class="col-12 py-4 fst-italic">
        <p class="text-secondary">
          <span class="text-quaternary text-500">
            {{ theme.description_title }}:
          </span>
          {{ theme.description }}
        </p>
      </div>
    </div>
    <div class="d-flex flex-column">
      <QuestionCard
        v-for="(question, key) in questions"
        :key="`question-${key}`"
        :question="question"
      />
      <EntityCommentTextarea
        :entity="theme"
        :entity-number="theme.theme_number"
        entity-type="themes"
      />
    </div>
  </div>
</template>

<script>
import QuestionCard from './QuestionCard.vue'
import EntityCommentTextarea from './EntityCommentTextarea.vue'
import EntityImgContainer from '../EntityImgContainer.vue'
export default {
  components: { QuestionCard, EntityCommentTextarea, EntityImgContainer },
  props: {
    theme: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    answersByQuestionId() {
      return this.$page.props.survey.responses.reduce(
        (acc, response) => ((acc[response.survey_question_id] = response), acc),
        {}
      )
    },
    questions() {
      return this.theme.questions.reduce(
        (acc, question) => (
          (acc[question.id] = this.addResponseValue(question)), acc
        ),
        {}
      )
    },
    themeTitle() {
      return `${this.theme.theme_number} - ${this.theme.name}`
    },
    themeImage() {
      return this.theme.image
    },
    textAreaReference() {
      return `textarea-${this.theme.theme_number}`
    },
  },
  mounted() {
    setTimeout(() => {
      this.scrollToElement()
    }, 1)
  },
  methods: {
    addResponseValue(question) {
      question.value = null
      if (this.answersByQuestionId[question.id]) {
        question.value = this.answersByQuestionId[question.id].value
      }
      return question
    },
    scrollToElement() {
      if (this.isSelected) {
        const headerHeight =
          document.querySelector('header').firstChild.clientHeight
        const yOffset = -headerHeight

        const element = this.$el
        let y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset

        if (this.theme.display_order == 1) {
          y = 0
        }
        window.scrollTo({
          top: y,
          behavior: 'smooth',
        })
      }
    },
  },
}
</script>
